// extracted by mini-css-extract-plugin
export default {"vippsCheckoutIframe":"VippsCheckoutPage_vippsCheckoutIframe__lJ3XH","Loading":"VippsCheckoutPage_Loading__zwDwD"};